import React from 'react';
import styled from 'styled-components';
import {
  standardColours,
  brandColours,
  greyColours,
  standardTransition,
} from '../../styles';

const StyledToggle = styled.div``;

const StyledToggleWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 57px;
  height: 29px;
  margin: 0 10px;
`;

const StyledToggleControl = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${greyColours.lightGrey};
  border-radius: 34px;

  &:before {
    position: absolute;
    content: '';
    height: 22px;
    width: 22px;
    left: 4px;
    bottom: 4px;
    background-color: ${standardColours.white};
    transition: ${standardTransition('transform')};
    border-radius: 50%;
  }
`;

const StyledToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked {
    + ${StyledToggleControl} {
      background-color: ${brandColours.primary};

      &:before {
        transform: translateX(26px);
      }
    }
  }
`;

export const Toggle = ({ setToggleState, toggleState, children, ...props }) => (
  <StyledToggle {...props}>
    <StyledToggleWrapper>
      <StyledToggleInput
        type="checkbox"
        checked={toggleState}
        onClick={() => setToggleState(!toggleState)}
      />
      <StyledToggleControl />
    </StyledToggleWrapper>
  </StyledToggle>
);
